<template>
    <ShowTemplate
        :model="event"
        :owners="[event.eventable].filter((owner) => owner != null)"
        :otherOwner="event.organization"
        :otherOwnerTitle="$lang.get('Organized by')"
        :descriptionTabs="descriptionTabs"
        :can="permissions"
        :access="event.access"
        :rolePanels="rolePanels"
        :availableEmotions="availableEmotions"
        :relations="relations"
        :sidebarRelations="organizationRelations"
        :statistics="statistics"
    >
        <template #LinkSlot>
            <div class="mt-2">
                <p
                    v-text="
                        $lang.get('Dates for :definitive_model', {
                            definitive_model: $getBaseModelTranslation({
                                modelName: 'event',
                                wordClass: 'definitive',
                            }),
                        })
                    "
                />
                <div
                    class="rounded-full bg-event-accent text-event font-medium px-2 py-1 w-fit"
                    v-text="
                        `${$moment(event.start).format('L')} - ${$moment(
                            event.end
                        ).format('L')}`
                    "
                />
            </div>
        </template>
    </ShowTemplate>
</template>

<script>
import ShowTemplate from '@/Templates/ShowTemplate.vue'

export default {
    components: {
        ShowTemplate,
    },

    props: {
        event: {
            type: Object,
            required: true,
        },
        permissions: {
            type: Object,
            required: true,
        },
        rolePanels: {
            type: Array,
            required: true,
        },
        availableEmotions: {
            type: Array,
            required: true,
        },
        resources: {
            type: Object,
            default: {},
        },
        organizations: {
            type: Object,
            default: {},
        },
        statistics: {
            type: Object,
            default: {},
        },
        events: {
            type: Object,
            default: {},
        },
    },

    computed: {
        descriptionTabs() {
            return [
                {
                    id: 'description',
                    name: this.$lang.get('Summary'),
                    content: this.event.description,
                },
                {
                    id: 'objectives',
                    name: this.$lang.get('Objectives'),
                    content: this.event.objectives,
                },
                {
                    id: 'information',
                    name: this.$lang.get('Information'),
                    content: this.event.information,
                },
                {
                    id: 'rules',
                    name: this.$lang.get('Objectives'),
                    content: this.event.rules,
                },
                {
                    id: 'notes',
                    name: this.$lang.get('Information'),
                    content: this.event.notes,
                },
            ].filter((tab) => !!tab.content)
        },

        relations() {
            return [this.resources, this.events, this.organizations].filter(
                (relation) => Object.keys(relation).length > 0
            )
        },
        organizationRelations() {
            return [this.organizations].filter(
                (relation) => Object.keys(relation).length > 0
            )
        },
    },
}
</script>
